// extracted by mini-css-extract-plugin
export var badgeTextContainer = "_5h-2";
export var blackBorderOnHover = "_5h-7";
export var cell = "_5h-6";
export var cellContainer = "_5h-3";
export var checked = "_5h-8";
export var disabled = "_5h-5";
export var featuredIconCellContainer = "_5h-9";
export var featuredIconTextContainer = "_5h-b";
export var featuredIconWrapper = "_5h-a";
export var noBorder = "_5h-c";
export var orangeSelectedRow = "_d6-3";
export var overflowableText = "_5h-0";
export var overflowableTextContainer = "_5h-1";
export var row = "_5i-0";
export var rowCheckboxCell = "_5h-4";
export var selectableTable = "_d6-2";